export default "__VITE_ASSET__077e9c6f__"